if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

      // Initialize active/fallback states
      const initialActiveBtn = this.elements.thumbnails.querySelector('button[aria-current="true"]');
      if (initialActiveBtn) {
        const li = initialActiveBtn.closest('.thumbnail-list__item');
        if (li) li.classList.add('is-active');
      }
      this.updateThumbnailFallbackState();
      this.updateSlideFallbackState();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');
      this.updateSlideFallbackState();

      const isVariantImage = activeMedia.classList.contains('product__media-item--variant') || activeMedia.classList.contains('dpo-variant-image');
      if (prepend && (!isVariantImage || this.dataset.desktopLayout === 'columns')) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail && (!activeThumbnail.classList.contains('dpo-variant-thumb') || this.dataset.desktopLayout === 'columns')) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        if (this.elements.thumbnails && this.elements.thumbnails.slider) this.elements.thumbnails.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);

      // If the thumbnail for this media is hidden (dpo-variant-thumb), don't disrupt
      // the visible thumbnail state — keep whichever default thumb is currently active.
      const isHisAndHer = this.classList.contains('lwb-his-and-her-gallery-wrapper');
      if (isHisAndHer && activeThumbnail && activeThumbnail.classList.contains('dpo-variant-thumb')) return;

      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail ? activeThumbnail.dataset.mediaPosition : 1);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('.thumbnail-list__item').forEach((li) => li.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
      this.updateThumbnailFallbackState();

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.slider) this.elements.thumbnails.resetPages();
      
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      if (isDesktop) {
        // Vertical scrolling for desktop side slider
        const container = this.elements.thumbnails.querySelector('.thumbnail-list');
        if (container) {
          const containerTop = container.scrollTop;
          const containerBottom = containerTop + container.clientHeight;
          const elemTop = thumbnail.offsetTop;
          const elemBottom = elemTop + thumbnail.offsetHeight;
          
          if (elemTop < containerTop || elemBottom > containerBottom) {
            container.scrollTo({
              top: elemTop - (container.clientHeight / 2) + (thumbnail.offsetHeight / 2),
              behavior: 'smooth'
            });
          }
        }
      } else {
        // Horizontal scrolling for mobile
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    updateThumbnailFallbackState() {
      if (!this.elements.thumbnails) return;
      const variantThumbs = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item.lwb-thumb-variant');
      let hasActiveVariant = false;
      variantThumbs.forEach((thumb) => {
        if (thumb.classList.contains('is-active')) {
          hasActiveVariant = true;
        }
        thumb.classList.remove('is-fallback');
      });

      if (!hasActiveVariant) {
        const fallbackThumb = this.elements.thumbnails.querySelector('.lwb-thumb-variant-5') || this.elements.thumbnails.querySelector('.lwb-thumb-variant');
        if (fallbackThumb) {
          fallbackThumb.classList.add('is-fallback');
        }
      }
    }

    updateSlideFallbackState() {
      const viewer = this.elements.viewer;
      if (!viewer) return;
      const variantSlides = viewer.querySelectorAll('.product__media-item.lwb-slide-variant');
      let hasActiveVariant = false;
      variantSlides.forEach((slide) => {
        if (slide.classList.contains('is-active')) {
          hasActiveVariant = true;
        }
        slide.classList.remove('is-fallback');
      });

      if (!hasActiveVariant) {
        const fallbackSlide = viewer.querySelector('.lwb-slide-variant-5') || viewer.querySelector('.lwb-slide-variant');
        if (fallbackSlide) {
          fallbackSlide.classList.add('is-fallback');
        }
      }
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
